// https://docs.newrelic.com/docs/browser/new-relic-browser/browser-agent-spa-api/add-page-action/
export default function addNewRelicPageAction(
    actionName: string,
    attributes: { [key: string]: any },
): void {
    if (!window.newrelic) return

    window.newrelic.addPageAction(actionName, attributes)
}
